// extracted by mini-css-extract-plugin
module.exports = {"root":"ExperienceListItem_root__LmTRM","infoWrapper":"ExperienceListItem_infoWrapper__nA7a_"};